import { render, staticRenderFns } from "./SignUpFlow.vue?vue&type=template&id=89371904&"
import script from "./SignUpFlow.vue?vue&type=script&lang=js&"
export * from "./SignUpFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports